<app-header (logOutEvent)="receiveLogOut($event)"></app-header>
<app-side-nav (collapsedEvent)="receiveCollapsed($event)"
  *ngIf="(isLoggedIn | async) && (!fhirEmbedded || fhirFullSite)">
</app-side-nav>
<section [className]="(isLoggedIn | async) && (!fhirEmbedded || fhirFullSite) ? 'main-container' : ''"
  [ngStyle]="{'margin-left': collapedSideBar ? '50px' : ''}">
  <div (resized)="onResized($event)" [ngClass]="{collapsed: collapedSideBar}">
    <router-outlet>
      <!--Unsaved changes dialog-->
      <kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="unsavedDialogOpened"
        (close)="continueUnsaved(false)" [minWidth]="250" [width]="450">
        <p>{{ 'NOT-SAVED-CONFIRMATION' | translate }}</p>
        <kendo-dialog-actions>
          <button kendoButton (click)="continueUnsaved(false)" [primary]="true">{{ 'NO' | translate }}</button>
          <button kendoButton (click)="continueUnsaved(true)">{{ 'YES' | translate }}</button>
        </kendo-dialog-actions>
      </kendo-dialog>
      <!--Idle timeout dialog-->
      <kendo-dialog id="idleModal" title="{{ 'IDLE-TITLE' | translate }}" *ngIf="idleDialogOpened" class="idle-modal"
        [minWidth]="250" [width]="450">
        <div class="form-group text-center">
          <span *ngIf="idleCountdown > 1" translate [translateParams]="{value: idleCountdown}">{{ 'IDLE-TIMEOUTS' }}
          </span>
          <span *ngIf="idleCountdown === 1" translate [translateParams]="{value: idleCountdown}">{{ 'IDLE-TIMEOUT' }}
          </span>
        </div>
        <div class="form-group">
          <div class="progress">
            <div class="progress-bar bg-warning progress-bar-striped" [ngStyle]="{ width: progressPercent + '%'}"></div>
          </div>
        </div>
      </kendo-dialog>
    </router-outlet>
  </div>
</section>
<!--Chat window-->
<app-chat-window></app-chat-window>